<app-auth-layout>
    <mat-card-title>
        <h1 class="text-2xl font-bold text-neutral-800">
            Welcome back
        </h1>
        <p class="text-sm text-neutral-500 font-normal mt-1">
            Sign in to manage orders, products and customers
        </p>
    </mat-card-title>
    <mat-card-content>
        <form #userLogin="ngForm" (ngSubmit)="onSubmit(userLogin)">
            <div class="mt-5">
              <label class="text-sm font-medium text-neutral-700" for="email">Username</label>
              <div class="mt-1">
                <input
                  id="email"
                  class="p-2.5 rounded-lg border border-neutral-300 bg-neutral-50 w-full transition-colors focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400"
                  name="email"
                  type="email"
                  autocomplete="email"
                  placeholder="you@nustone.co.uk"
                  [(ngModel)]="email"
                  required
                  #emailInput="ngModel"
                />
              </div>
              @if (emailInput.invalid && (emailInput.dirty || emailInput.touched)) {
              <div class="mt-1 text-xs text-red-500">
                @if (emailInput.errors?.['required']) {
                <span>Email is required</span>
                }
              </div>
              }
            </div>
            <div class="mt-4">
              <label class="text-sm font-medium text-neutral-700" for="password">Password</label>
              <div class="mt-1 relative">
                <input
                  id="password"
                  class="p-2.5 pr-10 rounded-lg border border-neutral-300 bg-neutral-50 w-full transition-colors focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400"
                  name="password"
                  [type]="showPassword ? 'text' : 'password'"
                  autocomplete="current-password"
                  placeholder="Your password"
                  [(ngModel)]="password"
                  required
                  #passwordInput="ngModel"
                />
                <button
                  type="button"
                  class="absolute inset-y-0 right-0 flex items-center px-2.5 text-neutral-500 hover:text-neutral-700"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                  (click)="togglePasswordVisibility()"
                  tabindex="-1"
                >
                  <mat-icon fontIcon="{{ showPassword ? 'visibility_off' : 'visibility' }}"></mat-icon>
                </button>
              </div>
              @if (passwordInput.invalid && (passwordInput.dirty ||
              passwordInput.touched)) {
              <div class="mt-1 text-xs text-red-500">
                @if (passwordInput.errors?.['required']) {
                <span>Password is required</span>
                }
              </div>
              }
            </div>
            <div class="mt-4 flex flex-row justify-between items-center">
              <label class="text-xs text-neutral-600 flex items-center cursor-pointer">
                <input name="remember-next-login" type="checkbox" class="mr-2 accent-amber-500 h-4 w-4 cursor-pointer" [(ngModel)]="rememberMe" />
                Remember Me
              </label>
              <a
                class="text-amber-600 hover:text-amber-700 text-xs font-medium underline"
                routerLink="/forgot-password"
                >Forgot Password</a
              >
            </div>
            <div class="mt-6">
              <button type="submit" [disabled]="submitting"
                class="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:shadow-lg hover:shadow-amber-300 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed disabled:shadow-none">
                @if (submitting) {
                  <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span>
                  Logging in&hellip;
                } @else {
                  Login
                }
              </button>
            </div>
          </form>
    </mat-card-content>
</app-auth-layout>
